import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  id: "range-slider-label",
  class: "visually-hidden"
}
const _hoisted_3 = { class: "slide-min" }
const _hoisted_4 = { class: "slide-max" }

import Slider from '@vueform/slider'
import '@vueform/slider/themes/default.css'
import { ref, PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoryRangeSlider',
  props: {
    modelValue: {
        type: Array as PropType<number[]>,
        required: true,
    },
    min: { type: Number },
    max: { type: Number },
    dir: String,
    sliderDateRange: String,
    disabled: { type: Boolean },
},
  emits: ["update:modelValue", "input", "update"],
  setup(__props, { emit }: { emit: ({
    (event: 'update:modelValue', payload: number[]): void
    (event: 'input', payload: number[]): void
    (event: 'update', payload: number[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;



const internalValue = ref<number[]>([...props.modelValue])

const sliderOptions = ref<Object>({
    direction: props.dir,
})



const updateValue = (value) => {
    emit('input', value)
    emit('update:modelValue', value)
    emit('update', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "range-slide",
    "aria-label": __props.sliderDateRange
  }, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.sliderDateRange), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.min), 1),
    _createVNode(_unref(Slider), {
      modelValue: internalValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
      onUpdate: updateValue,
      min: __props.min,
      max: __props.max,
      tooltipPosition: "bottom",
      ariaLabelledby: "range-slider-label",
      options: sliderOptions.value,
      disabled: __props.disabled
    }, null, 8, ["modelValue", "min", "max", "options", "disabled"]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(__props.max), 1)
  ], 8, _hoisted_1))
}
}

})